'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@algoacademy/design-system/shared/cn';
import { AnimatePresence, motion } from 'framer-motion';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
const NAV_ITEMS = [{
  href: '/aplikacje',
  label: 'Aplikacje'
}, {
  href: '/zespol',
  label: 'Zespół'
}, {
  href: '/partnerzy',
  label: 'Partnerzy'
}, {
  href: '/o-nas',
  label: 'O nas'
}];
function LabMark() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Algolabs</title>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <stop offset="0%" style={{
      stopColor: "var(--color-algoprimary)"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" className="shrink-0">{t0}<defs><linearGradient id="labMarkGradient" x1="0" y1="0" x2="28" y2="28">{t1}<stop offset="100%" style={{
            stopColor: "var(--color-algosecondary)"
          }} /></linearGradient></defs><circle cx="6" cy="21" r="2.5" fill="url(#labMarkGradient)" /><circle cx="14" cy="7" r="2.5" fill="url(#labMarkGradient)" /><circle cx="22" cy="21" r="2.5" fill="url(#labMarkGradient)" /><path d="M6 21 14 7 22 21" stroke="url(#labMarkGradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function SiteHeader() {
  const $ = _c(39);
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const onScroll = () => setScrolled(window.scrollY > 8);
      onScroll();
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMobileOpen(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pathname) {
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: -16
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.5,
      ease: "easeOut"
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  const t7 = scrolled ? "shadow-lg" : "";
  let t8;
  if ($[8] !== t7) {
    t8 = cn("sticky top-0 z-50 w-full border-borderPrimary border-b bg-backgroundSecondary/80 backdrop-blur-md transition-shadow duration-300", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="/" className="group flex items-center gap-2.5 rounded-md font-bold text-contentPrimary text-xl tracking-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary"><LabMark /><span className="transition-colors group-hover:text-algoprimary">Algolabs</span></Link>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== pathname) {
    t10 = NAV_ITEMS.map(item => {
      const active = pathname === item.href;
      return <li key={item.href}><Link href={item.href} aria-current={active ? "page" : undefined} className={cn("relative rounded-md px-3 py-2 font-medium text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary", active ? "text-contentPrimary" : "text-contentSecondary hover:text-contentPrimary")}>{item.label}{active && <motion.span layoutId="site-header-active" className="absolute inset-x-3 -bottom-px h-px bg-algoprimary" />}</Link></li>;
    });
    $[11] = pathname;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <ul className="hidden items-center gap-1 sm:flex">{t10}</ul>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setMobileOpen(_temp);
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = mobileOpen ? "Zamknij menu" : "Otw\xF3rz menu";
  const t14 = mobileOpen ? "Zamknij menu" : "Otw\xF3rz menu";
  let t15;
  if ($[16] !== t14) {
    t15 = <title>{t14}</title>;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== mobileOpen) {
    t16 = mobileOpen ? <path d="M4 4 18 18M18 4 4 18" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" /> : <path d="M3 6h16M3 11h16M3 16h16" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />;
    $[18] = mobileOpen;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t15 || $[21] !== t16) {
    t17 = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">{t15}{t16}</svg>;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== mobileOpen || $[24] !== t13 || $[25] !== t17) {
    t18 = <button type="button" onClick={t12} aria-expanded={mobileOpen} aria-controls="site-header-mobile-menu" aria-label={t13} className="flex size-11 items-center justify-center rounded-md text-contentPrimary transition-colors hover:bg-backgroundHoverOverlay focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary sm:hidden">{t17}</button>;
    $[23] = mobileOpen;
    $[24] = t13;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t11 || $[28] !== t18) {
    t19 = <nav className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-6">{t9}{t11}{t18}</nav>;
    $[27] = t11;
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== mobileOpen || $[31] !== pathname) {
    t20 = mobileOpen && <motion.div id="site-header-mobile-menu" initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: "easeOut"
    }} className="overflow-hidden border-borderPrimary border-t sm:hidden"><ul className="flex flex-col gap-1 px-6 py-4">{NAV_ITEMS.map(item_0 => {
          const active_0 = pathname === item_0.href;
          return <li key={item_0.href}><Link href={item_0.href} onClick={() => setMobileOpen(false)} aria-current={active_0 ? "page" : undefined} className={cn("flex min-h-11 items-center rounded-md px-3 font-medium text-base transition-colors hover:bg-backgroundHoverOverlay hover:text-contentPrimary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-algoprimary", active_0 ? "text-contentPrimary" : "text-contentSecondary")}>{item_0.label}</Link></li>;
        })}</ul></motion.div>;
    $[30] = mobileOpen;
    $[31] = pathname;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t20) {
    t21 = <AnimatePresence>{t20}</AnimatePresence>;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t19 || $[36] !== t21 || $[37] !== t8) {
    t22 = <motion.header initial={t4} animate={t5} transition={t6} className={t8}>{t19}{t21}</motion.header>;
    $[35] = t19;
    $[36] = t21;
    $[37] = t8;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  return t22;
}
function _temp(open) {
  return !open;
}